(function () {
	const artists = window.artistsData || [];

	// The A-Z bar belongs to the full artists list only. Other sections on the
	// page (Featured Artists) reuse the same card markup, so every lookup below
	// is scoped to this grid instead of the whole document.
	let grid = null;
	let filterContainer = null;

	function getDataLetter(name) {
		if (!name) return '#';
		const firstLetter = name.trim().charAt(0).toUpperCase();
		if (firstLetter >= '0' && firstLetter <= '9') {
			return '#';
		}
		return firstLetter;
	}

	function getLetterCounts() {
		const counts = {};
		for (let i = 65; i <= 90; i++) {
			counts[String.fromCharCode(i)] = 0;
		}
		counts['#'] = 0;

		artists.forEach((artist) => {
			if (!artist.title) return;
			const letter = getDataLetter(artist.title);
			if (counts.hasOwnProperty(letter)) {
				counts[letter] = (counts[letter] || 0) + 1;
			}
		});

		return counts;
	}

	function applyFilter(letter) {
		if (!grid) return;
		const cards = grid.querySelectorAll('.artist-card');
		const filterButtons = filterContainer
			? filterContainer.querySelectorAll('.az-filter-letter')
			: [];
		const letterLower = letter ? letter.toLowerCase() : '';

		filterButtons.forEach((button) => {
			const buttonLetter = button.dataset.letter;
			const isActive =
				buttonLetter === letterLower ||
				(letterLower === 'all' && buttonLetter === 'all') ||
				(letter === '#' && buttonLetter === '#');

			button.classList.toggle('az-filter-letter--active', isActive);
		});

		if (!letter || letter === 'ALL') {
			cards.forEach((card) => card.classList.remove('artist-card-hidden'));
		} else if (letter === '#') {
			cards.forEach((card) => {
				card.classList.toggle('artist-card-hidden', card.dataset.letter !== '#');
			});
		} else {
			const letterUpper = letter.toUpperCase();
			cards.forEach((card) => {
				card.classList.toggle('artist-card-hidden', card.dataset.letter !== letterUpper);
			});
		}

		const url = new URL(window.location);
		if (letter && letter !== 'ALL') {
			url.searchParams.set('letter', letter.toLowerCase());
		} else {
			url.searchParams.delete('letter');
		}
		window.history.pushState({}, '', url);
	}

	function renderAzFilter() {
		const letterCounts = getLetterCounts();
		let filterHTML = '<div class="artists-az-filter-wrapper">';

		const isAllActive = !selectedLetter || selectedLetter === 'ALL';
		filterHTML += `<button class="az-filter-letter ${isAllActive ? 'az-filter-letter--active' : ''}" data-letter="all">
			<span>ALL</span>
		</button>`;
		filterHTML += `<span class="az-filter-sep">/</span>`;

		for (let i = 65; i <= 90; i++) {
			const letter = String.fromCharCode(i);
			const count = letterCounts[letter] || 0;
			const isActive = selectedLetter === letter;
			const isDisabled = count === 0;

			filterHTML += `<button class="az-filter-letter ${isActive ? 'az-filter-letter--active' : ''} ${isDisabled ? 'az-filter-letter--disabled' : ''}" data-letter="${letter.toLowerCase()}" ${isDisabled ? 'disabled' : ''}>
				<span>${letter}</span>
			</button>`;

			if (i < 90) {
				filterHTML += `<span class="az-filter-sep">/</span>`;
			}
		}

		const hashCount = letterCounts['#'] || 0;
		const isHashActive = selectedLetter === '#';
		const isHashDisabled = hashCount === 0;

		filterHTML += `<span class="az-filter-sep">/</span>`;
		filterHTML += `<button class="az-filter-letter ${isHashActive ? 'az-filter-letter--active' : ''} ${isHashDisabled ? 'az-filter-letter--disabled' : ''}" data-letter="#" ${isHashDisabled ? 'disabled' : ''}>
			<span>#</span>
		</button>`;

		filterHTML += '</div>';

		filterContainer = grid.parentNode.querySelector('.artists-az-filter');
		if (!filterContainer) {
			filterContainer = document.createElement('div');
			filterContainer.className = 'artists-az-filter';
			grid.parentNode.insertBefore(filterContainer, grid);
		}
		filterContainer.innerHTML = filterHTML;

		filterContainer.querySelectorAll('.az-filter-letter').forEach((btn) => {
			if (!btn.disabled) {
				btn.addEventListener('click', function () {
					const l = this.dataset.letter;
					applyFilter(l === 'all' ? 'ALL' : l === '#' ? '#' : l.toUpperCase());
				});
			}
		});
	}

	let selectedLetter = null;
	const urlParams = new URLSearchParams(window.location.search);
	const letterParam = urlParams.get('letter');
	if (letterParam) {
		selectedLetter = letterParam.toUpperCase() === 'ALL' ? 'ALL' : letterParam.toUpperCase();
	}

	function init() {
		grid = document.querySelector('[data-artist-grid]');
		if (!grid) return;
		renderAzFilter();
		applyFilter(selectedLetter || 'ALL');
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
